import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const TableCell = forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={twMerge(
      "h-16 w-fit px-6 text-sm text-neutral-40 dark:text-neutral-70",
      className,
    )}
    {...props}
  />
));
TableCell.displayName = "TableCell";
